// extracted by mini-css-extract-plugin
export default {"wrapper":"FoodInfo_wrapper__Ualh4","food-name":"FoodInfo_food-name__KUBe3"};